import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import FavoriteBorderIcon from '@material-ui/icons/FavoriteBorder';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { statuses } from './Utils';

const useStyles = makeStyles((theme) => ({
  hostStatus: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderRadius: '10px',
    marginLeft: theme.spacing(2), marginBottom: theme.spacing(2),
  },
  hostStatusColumnGreen: {
    height: 20,
    width: '100%',
    fontSize: 13,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '5px',
  },
  hostStatusColumnRed: {
    height: 20,
    width: '100%',
    fontSize: 13,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '5px',
  },
  hostStatusColumnYellow: {
    height: 20,
    width: '100%',
    fontSize: 13,
    display: 'flex',
    flexDirection: 'row',
    marginBottom: '5px',
  },
  statusColorGreen: {
    width: 5,
    marginRight: '20px',
    backgroundColor: theme.palette.icon.green4,
  },
  statusColorRed: {
    width: 5,
    marginRight: '20px',
    backgroundColor: theme.palette.icon.red4,
  },
  statusColorYellow: {
    width: 5,
    marginRight: '20px',
    backgroundColor: theme.palette.icon.yellow4,
  },
  hostStatusLabel: {
    width: '50%',
    color: theme.palette.base[800],
    textTransform: 'uppercase',
    marginBottom: '5px',
  },
  hostStatusValue: {
    width: '50%',
    color: theme.palette.base[800],
    textTransform: 'uppercase',
    textAlign: 'right',
    paddingRight: 25,
  },
}));

function HostStatuses(props) {
  const classes = useStyles();
  const { t } = useTranslation();

  const { host, hadleHostFavorite, isHostFavorite } = props;

  let hostStatus = host && host.message && host.message.split(',');
  hostStatus = hostStatus || [];

  const hostStatusTag = (status) => (
    status && status.name
      ? (
        <div
          className={
            status.color==='green' && classes.hostStatusColumnGreen ||
            status.color==='red' && classes.hostStatusColumnRed ||
            status.color==='yellow' && classes.hostStatusColumnYellow
        }
          key={`setting_${status.name}_${status.status}`}
        >
          <div
            className={
              status.color==='green' && classes.statusColorGreen ||
              status.color==='red' && classes.statusColorRed ||
              status.color==='yellow' && classes.statusColorYellow
           }
          />
          <div className={classes.hostStatusLabel}>{t(status.name)}</div>
          <div className={classes.hostStatusValue}>{status.name==='DisplayText'?host.displayText:t(status.status)}</div>
        </div>
      )
      : null
  );

  return (
    <>
      {host && host.message ? (
        <div className={classes.hostStatus}>
          <div style={{display: 'flex', flexDirection: 'row', marginLeft: '-7px', marginBottom: '10px'}}>
            <InfoOutlinedIcon style={{opacity: 0.5}} fontSize='small'/>
            <div style={{fontSize:14, opacity: 0.6, marginLeft: '20px'}}>{t('HOST_STATE').toUpperCase()}</div>
            <div style={{marginLeft:'auto', opacity: 0.5, cursor: 'pointer'}}>
              { isHostFavorite(host.parkingHostId, TYPE_FT_FLAG) && 
                <FavoriteIcon fontSize='small' onClick={()=>{hadleHostFavorite(host.parkingHostId, !isHostFavorite(host.parkingHostId, TYPE_FT_FLAG), TYPE_FT_FLAG)}}/>
              }
              { !isHostFavorite(host.parkingHostId, TYPE_FT_FLAG) && 
                <FavoriteBorderIcon fontSize='small' onClick={()=>{hadleHostFavorite(host.parkingHostId, !isHostFavorite(host.parkingHostId, TYPE_FT_FLAG), TYPE_FT_FLAG)}}/>
              }
            </div>
          </div>
          {hostStatus.map((hs) => {
            const status = hs && hs.replace('.', '_');
            return hostStatusTag(statuses[status]);
          })}
        </div>
      ) : null}
    </>
  );
}

HostStatuses.propTypes = {
  host: PropTypes.object,
};

HostStatuses.defaultProps = {
  host: { message: '' },
};

const TYPE_FT_FLAG = 'FT_FLAG';

export default HostStatuses;
